import { logEvent } from "firebase/analytics";
import { analytics } from "./firebaseconfig";

function itemCreator(product, quantity = 1) {
  let price = product.price;

  if (product.deposit > 0) price = price + product.deposit;

  return {
    item_id: product._id,
    item_name: product.name,
    price: price,
    currency: "SEK",
    quantity: quantity,
  };
}

export function user_signup() {
  // Log event when a product is added to the cart
  logEvent(analytics, "user_signup");
}

export function category_page_view(category, subCategory) {
  const categoryName =
    category.category.name +
    (subCategory ? " > " + subCategory.category.name : "");

  // Log event when a product is added to the cart
  logEvent(analytics, "category-page-view", {
    pageCategories: categoryName,
  });
}

export function search_product(term) {
  // Log event when a product is added to the cart
  logEvent(analytics, "search", {
    search_term: term,
  });
}

export function cart_done(cart) {
  const items = [];
  for (const p of cart.productVariants) {
    items.push(itemCreator(p.productVariant, p.quantity));
  }

  const params = {
    currency: "SEK",
    value: cart.price.total,
    items: items,
  };
  console.log("CART_DONE");
  logEvent(analytics, "cart_done", params);
}
export function log_add_to_cart(product, quantity = 1) {
  // Log event when a product is added to the cart
  logEvent(analytics, "add_to_cart", [itemCreator(product, quantity)]);
}
export function log_remove_form_cart(product, quantity = 1) {
  // Log event when a product is added to the cart
  logEvent(analytics, "remove_from_cart", [itemCreator(product, quantity)]);
}

export function log_view_item(product) {
  const items = [];

  items.push(itemCreator(product, 1));

  const params = {
    currency: "SEK",
    value: product.price,
    items: items,
  };
  logEvent(analytics, "view_item", params);
}

export function log_begin_checkout(cart) {
  const items = [];
  for (const p of cart.productVariants) {
    items.push(itemCreator(p.productVariant, p.quantity));
  }

  const params = {
    currency: "SEK",
    value: cart.price.total,
    items: items,
  };
  logEvent(analytics, "begin_checkout", params);
}

export function log_purchase(cart) {
  const items = [];
  for (const p of cart.productVariants) {
    items.push(itemCreator(p.productVariant, p.quantity));
  }

  const params = {
    transactionId: cart._id,
    currency: "SEK",
    value: cart.price.total,
    shipping: cart.price.deliveryFee,
    tax: cart.price.tax,
    coupon: cart.appliedPromotion != null ? cart.appliedPromotion.code : null,
    items: items,
  };
  logEvent(analytics, "purchase", params);
}
